export { default as wrapScriptTags } from './wrap-script-tags';
